module.exports = {
    useInstalled: () => { },
    useReachability: () => { },
    sendMessage: () => { }
}